import { SetProfilePicPage } from './pages/set-profile-pic';
import { SetTeamPage } from './pages/set-team';
import { SetThemePage } from './pages/set-theme';

export const routes = [
  {
    name: 'profilePic',
    path: 'profile-pic',
    page: <SetProfilePicPage />,
  },
  {
    name: 'team',
    path: 'team',
    page: <SetTeamPage />,
  },
  {
    name: 'theme',
    path: 'theme',
    page: <SetThemePage />,
  },
] as const;
